var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_3717_1477)" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M1.33333 8.50012C1.33333 10.2682 2.03571 11.9639 3.28595 13.2142C4.5362 14.4644 6.23189 15.1668 8 15.1668C9.76811 15.1668 11.4638 14.4644 12.714 13.2142C13.9643 11.9639 14.6667 10.2682 14.6667 8.50012C14.6667 6.73201 13.9643 5.03632 12.714 3.78608C11.4638 2.53583 9.76811 1.83346 8 1.83346C6.23189 1.83346 4.5362 2.53583 3.28595 3.78608C2.03571 5.03632 1.33333 6.73201 1.33333 8.50012ZM2.34315 14.157C0.842855 12.6567 0 10.6219 0 8.50012C0 6.37839 0.842855 4.34356 2.34315 2.84327C3.84344 1.34298 5.87827 0.500122 8 0.500122C10.1217 0.500122 12.1566 1.34298 13.6569 2.84327C15.1571 4.34356 16 6.37839 16 8.50012C16 10.6219 15.1571 12.6567 13.6569 14.157C12.1566 15.6573 10.1217 16.5001 8 16.5001C5.87827 16.5001 3.84344 15.6573 2.34315 14.157Z",
            fill: "#3561B8",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6.33333 7.50012C6.33333 7.13193 6.63181 6.83346 7 6.83346H7.5C7.80942 6.83346 8.10617 6.95637 8.32496 7.17516C8.54375 7.39396 8.66667 7.6907 8.66667 8.00012V10.5001C8.66667 10.5885 8.70179 10.6733 8.7643 10.7358C8.82681 10.7983 8.9116 10.8335 9 10.8335H9.5C9.86819 10.8335 10.1667 11.1319 10.1667 11.5001C10.1667 11.8683 9.86819 12.1668 9.5 12.1668H9C8.55797 12.1668 8.13405 11.9912 7.82149 11.6786C7.50893 11.3661 7.33333 10.9422 7.33333 10.5001V8.16679H7C6.63181 8.16679 6.33333 7.86831 6.33333 7.50012Z",
            fill: "#3561B8",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M7.75 5.66679C7.86051 5.66679 7.96649 5.62289 8.04463 5.54475C8.12277 5.46661 8.16667 5.36063 8.16667 5.25012C8.16667 5.13962 8.12277 5.03364 8.04463 4.95549C7.96649 4.87735 7.86051 4.83346 7.75 4.83346V4.33346C7.50688 4.33346 7.27373 4.43003 7.10182 4.60194C6.92991 4.77385 6.83333 5.00701 6.83333 5.25012C6.83333 5.49324 6.92991 5.72639 7.10182 5.8983C7.27373 6.07021 7.50688 6.16679 7.75 6.16679V5.66679Z",
            fill: "#3561B8",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M7.75 4.33346C7.99312 4.33346 8.22627 4.43003 8.39818 4.60194C8.57009 4.77385 8.66667 5.00701 8.66667 5.25012C8.66667 5.49324 8.57009 5.72639 8.39818 5.8983C8.22627 6.07021 7.99312 6.16679 7.75 6.16679V5.66679C7.63949 5.66679 7.53351 5.62289 7.45537 5.54475C7.37723 5.46661 7.33333 5.36063 7.33333 5.25012C7.33333 5.13962 7.37723 5.03364 7.45537 4.95549C7.53351 4.87735 7.63949 4.83346 7.75 4.83346V4.33346Z",
            fill: "#3561B8",
          },
        }),
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_3717_1477" } }, [
          _c("rect", {
            attrs: {
              width: "16",
              height: "16",
              fill: "white",
              transform: "translate(0 0.500122)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }